<script context="module">
  /**
   * determine whether to show or hide certain elements based on current path and an inclusion/exclusion list
   *
   * @param {string} currentPath
   * @param {string[]} pagesToShow
   * @param {string[]} pagesToHide
   */
  export function calculateVisibility(currentPath, pagesToShow = [], pagesToHide = []) {
    if (!pagesToShow.length && !pagesToHide.length) {
      return true;
    }

    if (!pagesToHide.length) {
      return pagesToShow.includes(currentPath);
    }

    if (!pagesToShow.length) {
      return !pagesToHide.includes(currentPath);
    }

    return pagesToShow.includes(currentPath) && !pagesToHide.includes(currentPath);
  }
</script>

<script>
  // @ts-check
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { Banner } from "@ObamaFoundation/of-design-system";

  import { BREAK_POINTS } from "$lib/utilities/constants";
  import { textToId } from "$lib/utilities/dom-helpers";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  import { mobileNavExpansionStore } from "$lib/stores";

  export let data;

  const linkVariantMap = {
    textLink: "textLink",
    outlinedLink: "outline",
    filledLink: "filled"
  };

  const {
    headline: title,
    copy: body,
    cta: ctaData,
    theme: themeName,
    pagesToShow,
    pagesToHide
  } = data?.fields || {};
  const cta = ctaData
    ? {
        text: ctaData.fields?.text,
        type: linkVariantMap[ctaData.fields?.type],
        url: ctaData.fields?.destination?.fields?.url,
        isExternal: isExternalUrl(ctaData.fields?.destination?.fields?.url),
        id: `banner-cta-${textToId(title)}`
      }
    : null;

  let isHidden = false;

  let screenWidth = 0;

  $: if (screenWidth && screenWidth < BREAK_POINTS.lg) {
    isHidden = $mobileNavExpansionStore;
  }

  $: shouldShowOnCurrentPage = calculateVisibility($page?.url?.pathname, pagesToShow, pagesToHide);
</script>

<svelte:window bind:innerWidth={screenWidth} />

{#if shouldShowOnCurrentPage}
  <Banner {title} {body} {cta} {themeName} {isHidden} />
{/if}

<slot />
